import React from 'react';
import { deletedata } from '../../util/global';

interface props {
  paymentdata: any[];
  subscriptiondata: any[];
}

// AdminPaymentTable: display-only grid of payment records
const AdminPaymentTable: React.FC<props> = ({ paymentdata, subscriptiondata }) => {
  const handleaction = async (item: any, action: string) => {
    if (action === 'delete') {
      if (window.confirm('Are you sure you want to delete this payment?')) {
        await deletedata({ filter: { _id: item._id, datatype: 'paymentdata' } }, () => {
          window.location.reload();
        });
      }
    }
  };

  const rows = paymentdata.map((item, i) => {
    const subscription = subscriptiondata?.find((s: any) => s._id === item._subscriptionid);

    return (
      <tr key={item._id || i}>
        <td style={{ width: '60px' }}>
          <select className="action-select" value="" onChange={(e) => handleaction(item, e.target.value)}>
            <option value="" disabled>{i + 1}</option>
            <option value="delete">Delete</option>
          </select>
        </td>
        <td>{item.createdat ? item.createdat.split('T')[0] : '-'}</td>
        <td>{item.billingenddate}</td>
        <td>{subscription?.name || '-'}</td>
        <td>{subscription?.label || '-'}</td>
        <td>{item._subscriptionid}</td>

        <td><strong>{item.gatewayorderid || '-'}</strong></td>
        <td><strong>{item.gatewaypaymentid || '-'}</strong></td>

        <td>₹{item.itemstotal}</td>
        <td>₹{item.deposittotal}</td>
        <td><strong>₹{item.totalamount}</strong></td>
        <td><span className={`status-badge ${item.status}`}>{item.status}</span></td>
        <td>{item.failurereason || '-'}</td>
      </tr>
    );
  });

  return (
    <table className="grid">
      <thead>
        <tr>
          <th>action</th>
          <th>date</th>
          <th>billing end date</th>
          <th>customer</th>
          <th>label</th>
          <th>subscriptionid</th>
          <th>gateway order id</th>
          <th>gateway payment id</th>

          <th>monthly</th>
          <th>deposit</th>
          <th>total</th>
          <th>status</th>
          <th>reason</th>
        </tr>
      </thead>
      <tbody>
        {rows.length > 0 ? rows : (
          <tr>
            <td colSpan={13} style={{ textAlign: 'center', padding: '16px' }}>No payments found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AdminPaymentTable;
